import useMyAccountLinks from 'components/notifications/hooks/use-my-account-links';
import {
  NOTIFICATION_INDICATOR,
  VIEW_ORDER_CTA
} from 'components/notifications/utils/constants';
import { getRedirectionLink } from 'components/notifications/utils/utils';
import { useTranslations } from 'next-intl';
import { useEsiteCtx } from 'services/esite/context';
import { Notification } from 'services/notifications/types';
import ExpiredStatusWrapper from './expired-status-wrapper/expired-status-wrapper';
import OrderStatusWrapper from './order-status-wrapper/order-status-wrapper';
import { StoreAddress } from 'components/dealer-locator/types';
import { normalizeCommerceLink } from 'utils/links';
import { EXPS } from 'components/notifications/constants';

interface NotificationCardFooterProps {
  notification: Notification;
  storeAddress: StoreAddress;
}

const NotificationCardFooter = ({
  notification,
  storeAddress
}: NotificationCardFooterProps) => {
  const t = useTranslations();
  const { catalogId, langId, storeId } = useEsiteCtx();
  const expiredQuote = t('EXPIRING_TODAY');
  const { dynamicLinks } = useMyAccountLinks(catalogId, storeId, langId);
  const {
    referenceId,
    orderNumber,
    reviewOrderLink,
    orderStatus,
    orderShipmentDetailsLink,
    reviewQuoteLink,
    quoteExpireDays
  } = notification;

  const redirectLink = normalizeCommerceLink(
    getRedirectionLink(dynamicLinks, referenceId, orderNumber, reviewOrderLink)
  );

  const orderShipmentDetailsLinkViewOrder =
    NOTIFICATION_INDICATOR[orderStatus] === 'VIEW_ORDER'
      ? orderShipmentDetailsLink
      : null;

  const orderShipmentLink = orderShipmentDetailsLinkViewOrder
    ? dynamicLinks.ORDER_STATUS.getUrl({
        orderId: referenceId.toString(),
        dbsOrderId:
          orderNumber ||
          orderShipmentDetailsLinkViewOrder
            ?.split('dbsOrderId=')
            ?.pop()
            ?.split('&')?.[0]
      })
    : null;

  const reviewQuoteDetailLink =
    orderStatus === 'EXP' &&
    !!referenceId &&
    `${dynamicLinks.PENDING_QUOTE_DETAIL.getUrl({
      orderId: referenceId.toString()
    })}&&orderStatus=Expired`;

  const reviewLink =
    reviewQuoteLink && !!referenceId
      ? dynamicLinks.PENDING_QUOTE_DETAIL.getUrl({
          orderId: referenceId.toString()
        })
      : reviewQuoteDetailLink;

  const notExpired =
    (quoteExpireDays === null || orderStatus === EXPS) &&
    orderStatus !== expiredQuote;

  return (
    !VIEW_ORDER_CTA.includes(orderStatus) &&
    (notExpired ? (
      <OrderStatusWrapper
        link={orderShipmentLink || redirectLink}
        reviewLink={reviewLink}
        orderStatus={orderStatus}
        storeAddress={storeAddress}
        notification={notification}
      />
    ) : (
      <ExpiredStatusWrapper
        link={reviewLink}
        quoteExpireDate={quoteExpireDays}
      />
    ))
  );
};

export default NotificationCardFooter;
